<figure class="sh-app-loading-msg">
    <img src="assets/images/logo/mediahaven-plain.svg" alt="Zeticon" class="sh-app-loading-msg__img" width="52" />
    <figcaption>{{ message }}</figcaption>
</figure>
